import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 35px;
  padding: 25px 35px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  min-height: calc(100vh - 80px - calc(35px * 2));

  @media (max-width: 768px) {
    margin: 16px;
    padding: 24px 19px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 17px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
`;

export const HeaderInfos = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderTitle = styled.h1`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 24px;
  line-height: 37px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 33px;
  }
`;

export const HeaderSubtitle = styled.h2`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  max-width: 381px;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  width: 100%;
  margin-top: 34px;
`;

export const Hr = styled.hr`
  border-color: ${({ theme }) => theme.colors.black};
  border-style: solid;
  margin: 10px 0px 20px 0px;
`;

type ShowTourProps = {
  showTour: false;
};

export const PanelContainer = styled.div<ShowTourProps>`
  width: 100%;
  height: 100%;
  max-width: 571px;
  min-height: 232px;

  display: flex;
  flex-direction: column;
  gap: 10px;

  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
      background-color: #ffff;
      padding: 4px;
      border-radius: 8px;
    `}
`;

export const ContractAdhesion = styled.a`
  border-radius: 4px;
  border: 1px solid #000fff;
  display: flex;
  padding: 12px 32px;
  justify-content: center;
  align-items: center;

  color: #000fff;
  text-align: center;
  font-family: "Mangueira", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;

  &:hover {
    text-decoration: none;
    color: #000fff;
  }
`;

export const ContractAdhesionWrap = styled.div`
  width: 100%;
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
